import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../styles/category.css";
import "../styles/cartpop.css";
import { ProductApi } from "../api/product.api";
import ProductListDisplay from "../components/weddigservice/ProductListDisplay";
import { MerchantApi } from "api/merchant.api";

function MerchantProductListPage() {
  const { merchantId } = useParams();
  const [products, setProducts] = useState([]);
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (isInitialLoad) {
      window.scrollTo(0, 0);
      setIsInitialLoad(false);
    }
  }, [isInitialLoad]);

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const response = await ProductApi.getProductsByMerchantId(merchantId);

      setProducts(response.products);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  }, [merchantId]);

  const fetchMerchant = useCallback(async () => {
    try {
      const response = await MerchantApi.getMerchantById(merchantId);
      setMerchant(response);
    } catch (error) {
      console.error("Error fetching merchant:", error);
    }
  }, [merchantId]);

  // Fetch category products
  useEffect(() => {
    fetchProducts();
    fetchMerchant();
  }, [fetchMerchant, fetchProducts]);

  return (
    <>
      <ProductListDisplay
        products={products}
        displayName={merchant?.displayName}
        isLoading={loading}
      />
    </>
  );
}

export default MerchantProductListPage;
